// extracted by css-extract-rspack-plugin
export default {"cls1":"CollapsedActivityPreview-cls1_Tla","cls2":"CollapsedActivityPreview-cls2_c9M CollapsedActivityPreview-cls1_Tla"};